import { manageGroup } from 'core/permissions';

export default {
  global: manageGroup,
  local: 'reporting.provider_report_local',
  local_managed: 'reporting.provider_report_local_managed',
};
